function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { currencyMap } from '../../../commons/currencyMap';
export var mapSerieData = function mapSerieData(data) {
  var dataMap = [];
  for (var i = 0; i < data.length; i++) {
    dataMap.push([Date.parse(data[i].datetime), parseFloat(data[i].price)]);
  }
  return dataMap;
};
export var addSerieToOptions = function addSerieToOptions(options, serie, fundClass) {
  var newOptions = _objectSpread({}, options);
  newOptions.series.push(serie);
  var _ref = fundClass.currency || {},
    _ref$code = _ref.code,
    code = _ref$code === void 0 ? 'EUR' : _ref$code;
  var currencySymbol = currencyMap[code];
  newOptions.yAxis = _objectSpread(_objectSpread({}, newOptions.yAxis), {
    labels: {
      format: "{value:.0f}".concat(currencySymbol),
      align: 'right'
    }
  });
  return newOptions;
};
export var getSerieTooltip = function getSerieTooltip(fundClass) {
  var _ref2 = fundClass.currency || {},
    _ref2$code = _ref2.code,
    code = _ref2$code === void 0 ? 'EUR' : _ref2$code;
  var currencySymbol = currencyMap[code];
  return {
    split: false,
    shared: true,
    crosshairs: false,
    xDateFormat: '%d-%m-%Y',
    pointFormat: "<span style=\"color:{series.color}\">Valor liquidativo</span>: <b>{point.y}".concat(currencySymbol, "</b><br/>"),
    changeDecimals: 2,
    valueDecimals: 2,
    followPointer: false
  };
};